'use client';
import React from 'react';
import { faBars } from '@fortawesome/pro-solid-svg-icons/faBars';
import { SimpleSearch } from './SimpleSearch';
import { NavigationLogo } from '../../NavigationLogo';
import { Icon } from '@benzinga/core-ui';
import styled from '@benzinga/themetron';

import { SimpleHeaderMenu } from './SimpleHeaderMenu';
import { NavigationMenus } from './SimpleHeader';
import { NavigationHeaderProps } from '../../../../entities';
interface SimpleHeaderMobileProps extends NavigationHeaderProps {
  menus?: NavigationMenus;
}

export const SimpleHeaderMobile: React.FC<SimpleHeaderMobileProps> = ({ logoVariant, menus }) => {
  const [menuVisible, setMenuVisible] = React.useState(false);

  return (
    <NavWrapper>
      <NavBar>
        <Icon className="text-xl" icon={faBars} onClick={() => setMenuVisible(true)} />
        <NavigationLogo deviceType="mobile" logoVariant={logoVariant} />
        <SimpleSearch />
      </NavBar>
      <SimpleHeaderMenu
        logoVariant={logoVariant}
        menus={menus?.primary ?? []}
        onClose={() => setMenuVisible(false)}
        visible={menuVisible}
      />
    </NavWrapper>
  );
};

const NavWrapper = styled.div`
  height: 64px;
`;

const NavBar = styled.div`
  background-color: #fff;
  height: 64px;
  padding: 0 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid rgb(232, 232, 232);
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 9999;
`;
